/**
 * Used for putting the incoming message into the state so message translator can 
 * act upon it
 */
export const PROCESS_INCOMING_MESSAGE = "PROCESS_INCOMING_MESSAGE";

//Used for marking that the message has been processed and can be removed
export const SET_IS_PROCESSED = "SET_IS_PROCESSED";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/clientcommunicator/src/actions/actionTypes.js